module.exports = __webpack_public_path__ + "a4b5b3034394799d4d68c8b59e77135a.png";